export default __webpack_public_path__ + "static/media/css3.d5935ac6.png";